import {useState} from "react";
import {Tab, Tabs, Box} from "@material-ui/core";
import {RenderIf} from "../render-if/RenderIf";

export const TabsComponent = (props:{
  headers:JSX.Element[],
  content:JSX.Element[],
  onTabSelectionChanged?: (tabIndex:number) => void
 
})=>{
    const [value, setValue] = useState(0);
    let {headers,content} = props;
    const handleChange = (event: any, newValue: number) => {
        setValue(newValue);
       
        var tabChangedTrigger = props.onTabSelectionChanged || null;
        
        if(tabChangedTrigger){
            tabChangedTrigger(newValue);
        }
    };
    
    return (
        <>
            <Tabs 
                value={value} 
                onChange={handleChange}
                aria-label="Medication tabs"
                TabIndicatorProps={{
                    style: {background: "var(--dna-alias-color-primary)"},
                }}
            >
                {headers.map((h,index)=>{
                    return <Tab key={index} label={h}/>
                })}
            </Tabs>
            {content.map((c,index)=>{
                return (
                    <RenderIf key={index} if={value == index}>
                        <Box  css ={{flex : 1}} 
                            role="tabpanel"                      
                        >
                            {c}
                        </Box>    
                    </RenderIf>
                    
                );
            })}
        </>
    );
};